import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { Tooltip, Popconfirm } from 'kts-components-antd-x4';
import {removeLoading} from 'kts-platform-frame/service/Tools';
import moment from 'moment';
import { PageHeaderFoot, Button, AutoTableContainer, Select, Drawer, Tag, Pagination, Table} from 'kts-xui';
import { AdvancedSearch, KtsForm } from 'kts-components';
import TagComponent from './TagTreeComponent';
import { LifeCycleTypes } from '@formily/antd';
import ModulesState from './Modules.State';
import { network, createCompany, tagmodule } from 'src/api'; 
import server from 'kts-platform-frame/service';
import ModulesAction from './Modules.Action';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import ModalCompanyDetail from './UI.Network.Modal.CompanyDetail';
import UITest from './UI.test';
const { Option } = Select;

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    loading: any;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    public columns = [
        {
            title: '公司名称',
            dataIndex: 'connectionName',
            width: 210,
        },
        {
            title: '纳税人识别号',
            dataIndex: 'connectionTaxId',
            width: 130,
        },
        {
            title: '国家或地区',
            dataIndex: 'country',
            width: 90,
        },
        {
            title: '城市',
            dataIndex: 'city',
            width: 90,
        },
        {
            title: '标签',
            dataIndex: 'labels',
            width: 170,
            render: (text, record) => {
                // 只显示前两个标签，后面的省略号标签标示，点击，显示下拉列表 
                return (<div className={css.onerowcontent} id="taglistid">
                    {text ? text.slice(0, 2).map((item, index) =>
                        <Tooltip key={index} title={item.labelName && item.labelName.length > 5 ? item.labelName : null}>
                            <Tag>{item.labelName && item.labelName.length > 5 ? item.labelName.substr(0, 5) + '...' : item.labelName}</Tag>
                        </Tooltip>) : ''}
                    {text && text.length > 2 && (
                        <Tooltip
                            placement="bottomLeft"
                            getPopupContainer={() => window.document.getElementById('taglistid')}
                            overlayStyle={{ maxHeight: '100px' }}
                            // placement="bottomRight" 
                            overlayClassName={css.tagsContent}
                            title={
                                <div className={css.tagcontain}>
                                    {text.slice(2, text.length).map((item, index) => <div className={css.tagrow} key={index}>{item.labelName}</div>)}
                                </div>
                            }
                        >
                            <Tag>...</Tag>
                        </Tooltip>
                    )
                    }
                </div>);
                // return text ? <Select {...tProps}>
                // {text.map((item, index)=><Option key={index}>{item.labelName}</Option>)}
                // </Select> : '';
                // return text && text.map((item, index)=>item.labelName ? <Tag key={index}>{item.labelName}</Tag> : '' );
            }
        },
        {
            title: '操作',
            dataIndex: 'operate',
            width: 100,
            render: (text, record) => {
                return (
                    <div>
                        <a onClick={this.onShowCompanyDetailModal.bind(this, record.connectionId)} >查看 </a>
                        <Popconfirm
                            title={
                                <div>
                                    <div> 您是否确定取消与该公司的网络连接？</div>
                                    <div className={`${css.smtips}`}> 取消连接后该公司将从您公司的网络中移除</div>
                                </div>
                            }
                            onConfirm={this.onCancelRelation.bind(this, record)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <a>取消</a>
                        </Popconfirm>
                    </div>
                );
            }
        }
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            pageMeta: null,
            list: [],
            params: {},
            countryList: [],
            viewDrawer: false,
            tagDrawer: false,
            tags: []
        };
    }
    componentDidMount() {
        this.getTags();
        // ModulesAction.initModulesStateMyList();
        // ModulesAction.pageListMyList(1);
        // this.test();
        const params = {
            pageNum: 1,
            pageSize: 10
        };
        this.getData(params);
        this.getCountry();
    }
    getTags = async () => {
        const res = await tagmodule.getAllTagAndCateList(this, null);
        let tagData = [];
        if (!res.er) {
            tagData = res.res && res.res.items && res.res.items.reduce((a: any, b: any) => {
                var c = a.concat(b.labels);
                return c;
            }, []);
            tagData = tagData.map(item => {
                return {
                    label: item.labelName,
                    value: item.labelId
                }
            })
            this.setState({
                tags: tagData
            })
        }
    }
    getCountry = async () => {
        const res = await createCompany.country(this, null);
        if (!res.er) {
            let list = [];
            if (res.res.countryList) {
                res.res.countryList.map((item, index) => {
                    var obj = { label: item.name, value: item.name };
                    list.push(obj);
                });
            }
            // 国家里面新增一个 无 选项
            // var none = { label: '无', value: null };
            // list.unshift(none);
            this.setState({
                countryList: list
            });
        }
    }
    /** 组件被卸载时，关闭右侧弹窗 */
    componentWillUnmount() {
        // ModulesAction.hideAside();
    }
    onSearch = (data: any = {}) => {

        this.setState({
            params: data
        });
        const params = {
            ...data,
            pageSize: 20,
            pageNum: 1,
        };
        this.getData(params);
    }
    getData = async (params?: any) => {
        if(!params){
            params = {
                ...this.state.params,
                pageSize: 20,
                pageNum: 1,
            }
        }
        let res = await network.myNetworkList(this, params);
        if (!res.er) { 
           await this.setState({
                pageMeta: res.res.pageMeta,
                list: res.res.items && res.res.items.map((item:any)=>({...item, labels: [...item.labels] }))
            });
        } 
    }
    topExpand = () => {
        return (
            <AdvancedSearch
                width={480}
                height={44}
                compact={true}
                defaultKey="fuzzyConnectionName"
                placeholder="请输入公司名称"
                searchFormSubmit={this.onSearch}
            >
                <KtsForm
                    labelCol={9}
                    wrapperCol={15}
                    labelAlign="left"
                    compact={true}
                    schema={{
                        type: 'object',
                        properties: {
                            fuzzyConnectionName: {
                                type: 'string',
                                title: '公司名称',
                            },
                            connectionTaxId: {
                                type: 'string',
                                title: '纳税人识别号',
                            },
                            country: {
                                type: 'string',
                                title: '选择国家',
                                enum: this.state.countryList,
                                'x-props': {
                                    allowClear: true
                                }
                            },
                            city: {
                                type: 'baseRef',
                                title: '选择地区',
                                visible: false,
                                'x-props': {
                                    searchKey: 'name',
                                    requestUrl: '/zone/company/location/query-cities',
                                    valueKey: 'name',
                                    labelKeys: ['name'],
                                },
                            },
                            labelIds: {
                                type: 'string',
                                title: '选择标签',
                                enum: this.state.tags,
                                'x-props': {
                                    allowClear: true,
                                    mode: "multiple"
                                }
                            }
                        },
                    }}
                    effects={($, actions) => {
                        $(LifeCycleTypes.ON_FIELD_VALUE_CHANGE, 'country').subscribe(
                            fieldState => {
                                if (!fieldState.value) {
                                    actions.setFieldState('city', state => {
                                        state.visible = false;
                                    });
                                } else {
                                    actions.setFieldState('city', state => {
                                        state.visible = true;
                                    });
                                }
                            },
                        );
                    }}
                >
                </KtsForm>
            </AdvancedSearch>
        );
    }
    closeTagManage = () => {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.removeHide, null);
    }
    freshData = () => {
        // 更新列表
        ModulesAction.pageListMyList(this.modulesState.stateMylist.pagination.current);
        // 更新标签查询列表
        ModulesAction.getCategoryAndTagData();

    }
    getonTagManage = () => {
        this.setState({
            tagDrawer: true
        })
        // MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
        //     Components: <TagComponent onclose={this.closeTagManage} onfresh={this.freshData} />,
        //     title: '标签库管理'
        // });
    }
    onExport = async () => {
        const params={
            ...this.state.params,
            pageNum:1,
            pageSize:this.state.pageMeta.total
        }
        let data = await server.post('/zone/network/connection/export', params).resFs([removeLoading]).responseType("blob").end(null);
        const blob = data.res.body;
        const downloadUrl = URL.createObjectURL(blob);  
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = `网络管理_${moment(new Date()).format("YYYYMMDDHHmmss")}.xls`;
        a.click();
        
    }
    onCloseTag = () => {
        this.setState({
            tagDrawer: false
        })
    }
    onPageChange = (pageNum, pageSize) => {
        this.setState({
            pageMeta: {
                ...this.state.pageMeta,
                pageNum,
                pageSize
            }
        }, () => {
            this.onRefresh();
        });
    }
    onRefresh = () => {
        const params = {
            ...this.state.params,
            ...this.state.pageMeta,
        };
        this.getData(params);
    }
    onCloseView = () => {
        this.setState({
            viewDrawer: false
        });
    }
    render() {
        const { list, pageMeta, viewDrawer, tagDrawer } = this.state;
 
        return (
            <div style={{ height: 'calc(100vh - 140px)', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flex: 'none', position: 'relative', zIndex: 1 }} className="special">
                    <PageHeaderFoot
                        expandLeft={this.topExpand()}
                        expandRight={[<Button key='0' onClick={this.getonTagManage}>标签库管理</Button>,
                        <Button key='1' onClick={this.onExport}>导出</Button>]}
                    >

                    </PageHeaderFoot>
                </div>
                <AutoTableContainer style={{ flex: 1, padding: '0 20px', backgroundColor: '#efefef' }} >
                    <Table
                        columns={this.columns}
                        bordered={true}
                        dataSource={list}
                        pagination={false}
                        rowKey="index"
                    />
                </AutoTableContainer>
                {pageMeta && <Pagination onChange={this.onPageChange} showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条,  共有 ${total} 条`} style={{ padding: '16px 0', flex: 'none', background: 'white', textAlign: 'center' }} total={pageMeta.total} pageSize={pageMeta.pageSize} current={pageMeta.pageNum} showSizeChanger={true} />}
                { viewDrawer &&
                    <Drawer
                        title='详情'
                        onClose={this.onCloseView}
                        visible={viewDrawer}
                        width={520}
                    >
                        <ModalCompanyDetail getData={this.getData}/>
                    </Drawer>
                }
                {
                    tagDrawer &&
                    <Drawer
                        title='标签库管理'
                        onClose={this.onCloseTag}
                        visible={tagDrawer}
                        width={490}
                    >
                        <TagComponent onclose={this.onCloseTag} onfresh={this.freshData} />
                    </Drawer>
                }
            </div>
        );
    }
    /** 查看详情 */
    private onShowCompanyDetailModal = async (companyId) => {
        await ModulesAction.networkCompayDetail(companyId);
        this.setState({
            viewDrawer: true
        });
        // MyStore.instance.dispatch(reducers.aside.ActionTypes.show, {
        //     Components: <ModalCompanyDetail />,
        //     title: '详情'
        // });
    }
    /** 取消连接 */
    private onCancelRelation = (rec) => {
        ModulesAction.sendCancelRelation({
            connectCompanyId: rec.connectionId,
        });
    }
    private test = () => {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <UITest />,
            title: '详情'
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Network.Admin.MyList.tsx